'use client'

import Tooltip from '@component/tooltip'
import IconLogo from '@icon/const/logo-desktop.svg?url'
import Image from 'next/image'
import { useBoolean } from 'react-use'
import DisablePrefetchLink from '@component/disablePrefetchLink'
import getRouter, { URLS } from '@router'

export default function HouseHr() {

  const [visible, toggleVisible] = useBoolean(false)
  return (
    <div className='grid items-center grid-cols-[1fr,auto,1fr] before:h-2 before:bg-neutral-1 after:h-2 after:bg-neutral-1 pt-40 md:pt-64'>
      <div className='border-2 border-neutral-1 px-24 py-16 rounded-sm text-center' onMouseEnter={() => toggleVisible(true)} onMouseLeave={() => toggleVisible(false)}>
        <Image src={IconLogo} alt='logo' width={133} height={24} unoptimized className='block mb-4'></Image>
        <Tooltip right disabled active={visible} content={
          <div className='px-16 py-10'>
            <DisablePrefetchLink prefetch={false} href={getRouter(URLS.propertyValuations)} className='whitespace-nowrap text-primary' target='_blank'>Learn more about our data<i className='icon icon-arrow-right !text-sm'></i></DisablePrefetchLink>
          </div>
        }>
          <span>Data <i className='icon icon-info text-secondary'></i></span>
        </Tooltip>
      </div>
    </div>
  )
}